import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  unknown: {
    description: '"unknown" delivery status option on shipment advanced filter',
    defaultMessage: 'Unknown',
    id: 'q8AQ3l',
  },
  inTransit: {
    description: '"in transit" delivery status option on shipment advanced filter',
    defaultMessage: 'In Transit',
    id: 'jRfE1o',
  },
  delivered: {
    description: '"delivered" delivery status option on shipment advanced filter',
    defaultMessage: 'Delivered',
    id: 'c7klUC',
  },
  undeliverable: {
    description: '"undeliverable" delivery status option on shipment advanced filter',
    defaultMessage: 'Undeliverable',
    id: 'pHlLY+',
  },
});
